import React, { useState, useEffect } from 'react';
import { Subtitle } from '../../components/titles';
import { LineSeparator } from '../../components/separators';
import { ButtonGradient, LinkGradient } from '../../components/Buttons';
import { THEME_COLORS } from '../../styles/theme';
import { ButtonLabel } from '../../components/Buttons/labels';
import {
    TitleAlreadyClient, ButtonWrapperRightMargin, ButtonWrapper, CallMeBackButtonMobile,
    Card, CardButtonAbsoluteContainer, CardTitle, CardText, Title, CallMeBackButtonWrapper, CardSpaceTopWrapper
} from './components';
import StyledLogo from '../../components/logo';
import { Icons } from '../../components/Icons';
import { ButtonIconWrapper, LinkOutsideSite } from '../../components/Buttons/style';
import { CallMeButton, CallMeLabel } from '../../components/Offer/style';
import { CallMeBackForm } from '../../components/CallMeBack/CallMeBackForm';
import { ChatCallContainer } from '../../components/ChatCallContainer';
import { setTrackerScript } from '../../tracking/setTracker';
import { getTrackingInfoOffer } from '../../tracking/getTrackingInfoOffer';
import { adfSendEvent } from '../../tracking/adfSendEvent';
import { DataLayerContainerHome } from "../../components/DataLayer";

export const WelcomePage = ({ offer, toggleCallMeBack }) => {
    const [isVisible, setIsVisible] = useState(false);
    const domain= window.location.host
    let ctaPrivate = ''
    if (domain == 'funnelvivigas.alkemy.com'){
        ctaPrivate= 'http://109.232.32.22/public/'
    }
    if (domain == 'localhost:3000') {
        ctaPrivate = 'https://pw.vivigas.it/public/'
    }
    if (domain == 'funnel.vivigas.it') {
        ctaPrivate = 'https://pw.vivigas.it/public/'
    }
    const CtaPrivateUrl = ctaPrivate
    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|landing' });
        }
    }, [offer]);

    return (
        <div className="container" style={{ marginBottom: '100px' }}>
            <DataLayerContainerHome />
            <ChatCallContainer 
                isCallMeVisible={false}
                trackerChat={() => adfSendEvent('vivigas|x|funnel|landing|click_chat')()}
                trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|landing|click_ti_chiamiamo_noi")()}
            />
            <StyledLogo />
            <div className="row justify-content-center margin-bottom-50">
                <div className="col-sm-10 col-lg-8 col-xl-6">
                    <Title>BENVENUTO! IN QUESTO PERCORSO EFFETTUERAI IL PASSAGGIO A VIVIGAS DA ALTRO FORNITORE.</Title>
                </div>
            </div>
            <div className="row justify-content-center margin-bottom-50">
                <div className="col-md-10">
                    <Subtitle><strong>Se hai un contratto con un altro fornitore e vuoi passare a Vivigas energia clicca ATTIVA. L’offerta che stai sottoscrivendo è dedicata ai clienti DOMESTICI. Se sei un’azienda, scopri le offerte <a href="https://www.vivigas.it/business/aziende">Luce e Gas per il business</a></strong></Subtitle>
                </div>
            </div>
            <div className="row justify-content-center margin-bottom-50">
                <div className="col-sm-8">
                    <LineSeparator />
                </div>
            </div>
            {/*
            <div className="row justify-content-center margin-bottom-16">
                <div className="col-sm-8 col-lg-6">
                    <TitleAlreadyClient>Sei già nostro Cliente?</TitleAlreadyClient>
                    <Subtitle>Se sei già Cliente VIVIgas e hai attiva una nostra offerta, clicca SI</Subtitle>
                </div>
            </div>
            <div className="row justify-content-center margin-bottom-40">
                <div className="col" style={{ display: 'flex', justifyContent: 'center' }}>
                    <ButtonWrapperRightMargin>
                        <LinkOutsideSite
                            href={CtaPrivateUrl}
                            mainColor={THEME_COLORS.pinkOrange}
                            hasOnlyOutline={true}
                            textColor={THEME_COLORS.red}
                            onClick={() => {
                                adfSendEvent('vivigas|x|funnel|landing|click_si')();
                            }}
                        >
                            <ButtonLabel color={THEME_COLORS.red}>
                                Si
                            </ButtonLabel>
                        </LinkOutsideSite>
                    </ButtonWrapperRightMargin>
                    <ButtonWrapper>
                        <LinkGradient 
                            mainColor={THEME_COLORS.pinkOrange} 
                            to="/dati-personali" 
                            onClick={() => adfSendEvent('vivigas|x|funnel|landing|click_no')()}
                        >
                            <ButtonLabel>
                                No
                            </ButtonLabel>
                        </LinkGradient>
                    </ButtonWrapper>
                </div>
            </div>
*/}
            <div className="row justify-content-center">
                <div className="col" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card hasBottomButton={true}>
                        <CardTitle className="margin-bottom-20">BENVENUTO</CardTitle>
                        <CardText>Ti guideremo nell'attivazione dell'offerta che hai scelto. Serviranno solo pochi minuti.</CardText>
                        <CardButtonAbsoluteContainer>
                            <ButtonWrapper>
                                <LinkGradient 
                                    mainColor={THEME_COLORS.blueViolet} 
                                    to="/dati-personali"
                                    onClick={() => {
                                        //leggo il cookie di tc commander
                                        let VivigasUIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                                        console.log('VivigasUId', VivigasUIdCookie)
                                        window.tC.event.confirmStep(this, {stepId: 'funnel_basket', user_id : `"${VivigasUIdCookie}"`})
                                        console.log('tCEvent-> confirmStep funnel_basket')
                                        adfSendEvent ( 'vivigas|x|funnel|landing|click_attiva' ) ()
                                    }}
                                >
                                    <ButtonLabel>
                                        Attiva
                                    </ButtonLabel>
                                </LinkGradient>
                            </ButtonWrapper>
                        </CardButtonAbsoluteContainer>
                    </Card>
                </div>
            </div>

            <div className="row justify-content-center margin-bottom-30" style={{ marginTop: '51px' }}>
                <div className="col-sm-8">
                    <LineSeparator />
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card hasBottomButton={false}>
                        <CardText>Per <strong>volture, subentri e nuove attivazioni </strong>contattaci al numero verde gratuito <b><a href="tel:+39800151313">800 15 13 13</a> </b>oppure trova il punto vendita a te più vicino e prenota un appuntamento.
                        </CardText>
                        <CardSpaceTopWrapper>
                            <CallMeBackButtonWrapper>
                                <LinkOutsideSite
                                    href="https://www.vivigas.it/punti-vendita/"
                                    target="_blank"
                                    mainColor={THEME_COLORS.blueViolet}
                                    hasOnlyOutline={true}
                                    textColor={THEME_COLORS.blue}
                                    onClick={() => adfSendEvent('vivigas|x|funnel|landing|click_trova_un_punto_vendita')()}
                                >
                                    <CallMeLabel color={THEME_COLORS.blue}>
                                        Prenota un appuntamento
                                    </CallMeLabel>
                                </LinkOutsideSite>
                            </CallMeBackButtonWrapper>
                        </CardSpaceTopWrapper>

                    </Card>
                </div>
            </div>
        </div>
    )
}